import
  styled
from "styled-components";

import
  colors
from "../../../config/colors";

import
  font
from "../../../config/fonts";

import {
  EnvConfig,
} from"../../../config/index";

export const HeaderContainer = styled.div`
  background-color: ${colors.White0};
  box-shadow: 0 0.125rem 0.25rem 0 rgb(136 136 136 / 10%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  padding: 0 16px;

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 6;
`;

export const HeaderSpace = styled.div`
  height: 70px;
`;

export const Logo = styled.div`
  background-image: url(${EnvConfig.imagePrefix}/assets/images/logo.png);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 40px;
  width: 40px;
`;

export const HContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Cart = styled.div`
  background-image: url(${EnvConfig.imagePrefix}/assets/images/cart.png);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  height: 22px;
  width: 22px;
`;

export const CartCounter = styled.div`
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 12px;
  line-height: 14px;
  background: ${colors.Green74};
  color: ${colors.White0};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -8px;
  right: -8px;
`;

export const Divider = styled.div`
  background-color: ${colors.Grey14};
  margin: 0 16px;
  width: 0.5px;
  height: 40px;
`;

export const Menu = styled.div`
  background-image: url(${EnvConfig.imagePrefix}/assets/images/${props => props.image});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 20px;
  width: 20px;
  margin: 0 2px 0 0;
`;

export const MenuContent = styled.div`
  background-color: ${colors.White0};
  position: fixed;
  top: 70px;
  left: 0;
  right: 0;
  overflow: hidden;
  z-index: 5;

  ${props => !props.show && `
    max-height: 0;
    transition: max-height 0.2s linear;
  `}

  ${props => props.show && `
    max-height: ${props.numberOfItems * 52}px;
    transition: max-height 0.2s linear;
  `}
`;

export const MenuContentItem = styled.div`
  background-color: ${colors.White0};
  display: flex;
  align-items: center;
  height: 52px;
  padding: 0 16px;
  border-bottom: 0.5px solid ${colors.Grey14};
  font-family: ${font.regular};
  font-size: 16px;
`;

export const MenuOverlayContainer = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 4;
`;